import FamilyRecordsModule from '../components/FamilyRecordsModule'
export default function FamilyCalendar(){
 return <FamilyRecordsModule module="events"/>
}
